
import { Auth, Signer } from 'aws-amplify';
import WebSocket from 'isomorphic-ws';

let WSService: any = null;

class WebSocketService {

    websocket: any;
    messageListeners: any[];
    isOpen: boolean;
    onConnectionOpenCallback: any;
    sessionId: string;
    ws: string;

    constructor(ws: string) {
        this.websocket = null;
        this.messageListeners = [];
        this.isOpen = false;
        this.onConnectionOpenCallback = () => {};
        this.sessionId = "";
        this.ws = ws;
    }

    /**
     *  Set up WebSocket connection for a new user and
     *  basic listeners to handle events
     */
    initSocket = async (sessionId: string, onConnectionOpenCallback: any) => {
        const wssUrl = `${this.ws}?sessionId=${sessionId}`;
        console.log("INITIALIZING WEB SOCKET", wssUrl);

        const credentials = await Auth.currentCredentials()

        const accessInfo = {
            access_key: credentials.accessKeyId,
            secret_key: credentials.secretAccessKey,
            session_token: credentials.sessionToken,
        }

        this.onConnectionOpenCallback = onConnectionOpenCallback;
        this.sessionId = sessionId;

        const signedUrl = Signer.signUrl(wssUrl, accessInfo)

        this.websocket = new WebSocket(signedUrl);
        this.websocket.onopen = () => this.onConnOpen(onConnectionOpenCallback);
        this.websocket.onmessage = this.onMessage;
        this.websocket.onclose = this.onConnClose;
    }

    /**
     *  Show connection status to us in the log
     */
    onConnOpen = (onConnectionOpenCallback: any) => {
        this.isOpen = true;
        onConnectionOpenCallback();
        console.log('Websocket connected!');
    }

    /**
     *  Log lost connection for now
     */
    onConnClose = () => {
        console.log('Websocket closed, reconnecting...');
        this.initSocket(this.sessionId, this.onConnectionOpenCallback);
    }

    hasListener = (listener: any) => {
        return this.messageListeners.some((l: any) => l.listener === listener);
    }

    /**
     *  Used by application to send message to the WebSocket API Gateway
     *  @param routeKey The route key for WebSocket API Gateway
     *  @param message String message
     *  message {
     *    room,
     *    type,
     *    msg,
     *    username,
     *    for
     *  }
     */
    sendMessage = (routeKey: any, message: any) => {
        if (this.websocket && this.isOpen) {
            this.websocket.send(JSON.stringify({
                rcaction: routeKey,
                rcmsg: JSON.stringify(message)
            }));
        } else {
            console.log(`Websocket connection not found!!`);
        }
    }

    /**
     *  Used by application to register different listeners for 
     *  different message types
     *  @param listener Function to handle message type
     */
    addMessageListener = (listener: any) => {
        if (typeof listener !== 'function') {
            return;
        }
        this.messageListeners.push({
            listener
        });
    }

    /**
     * Handler that receives the actual messages from the WebSocket API
     * For now it simply returns the parsed message body to the appropriate
     * registered handler
     * @param data Message body received from WebSocket 
     */
    onMessage = (data: any) => {
        if (data) {
            const message = JSON.parse(data.data);

            this.messageListeners.forEach((listener: any) => {
                listener.listener(message);
            });
        }
    }

    static initWSService(ws: string, sessionId: string, onConnectionOpenCallback: any): WebSocketService {
        if (!WSService) {
            WSService = new WebSocketService(ws);
            WSService.initSocket(sessionId, onConnectionOpenCallback);
            return WSService;
        } else {
            onConnectionOpenCallback();
        }

        return WSService;
    }

}

export const getWSService = WebSocketService.initWSService;
